import UnavailableFieldRow from "./UnavailableFieldRow";
import { ConfigurationPath } from "../../types/FormState.types";
import { useConfigurationField } from "../../context/ConfigurationFormContext";
import React from "react";
import { Box, Typography, TextField } from "@mui/material";

interface TextRowProps {
	label: string;
	caption: string;
	name: ConfigurationPath;
	value: string | null;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextRow: React.FC<TextRowProps> = ({
	label,
	caption,
	name,
	value,
	onChange,
}) => {
	const { error, disabled, readError } = useConfigurationField(name);
	if (readError) return <UnavailableFieldRow label={label} caption={caption} message={readError} />;
	return (
		<Box className="configuration-row">
			<Box>
				<Typography variant="body1">{label}</Typography>
				<Typography variant="caption">{caption}</Typography>
			</Box>
			<TextField
				name={name}
				disabled={disabled}
				error={Boolean(error)}
				helperText={error}
				sx={{ width: 220 }}
				value={value}
				onChange={onChange}
			/>
		</Box>
	);
};

export default TextRow;
